export default __webpack_public_path__ + "static/media/unchecked.45d3b8bb.svg";